import React, { useState, useEffect } from "react";
import StationsMap from "../components/StationsMap";
import Stations from "../components/Stations";
import useWindowDimensions from "../components/useWindowDimensions";
import { fetchStationsDaily } from "../store/stationsDaily";
import { fetchStationsHourly } from "../store/stationsHourly";
import { fetchStationsTwelve } from "../store/stationTwelve";
import { fetchStationsTwentyFour } from "../store/stationTwentyFour";
import { fetchInfo } from "../store/information";
// import { fetchStations, fetchKitHava } from "../store/stations";
import { useDispatch } from "react-redux";

const PayeshPage = () => {
  const { screenWidth, screenHeight } = useWindowDimensions();
  const [AQIType, setAQIType] = useState("daily");
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      switch (AQIType) {
        case "daily":
          dispatch(fetchStationsDaily());
          break;
        case "hourly":
          dispatch(fetchStationsHourly());
          break;
        case "twelve":
          dispatch(fetchStationsTwelve());
          break;
        case "twentyFour":
          dispatch(fetchStationsTwentyFour());
          break;
        default:
          break;
      }
      dispatch(fetchInfo());
    };

    fetchData();

    const intervalId = setInterval(fetchData, 900000); // 15 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [AQIType, dispatch]);

  return (
    <div
      className={
        screenWidth < 600
          ? "container-fluid g-0 overflow-y-scroll"
          : "container-fluid g-0 "
      }
    >
      <div className="row  g-0">
        <StationsMap AQIType={AQIType} setAQIType={setAQIType} />
      </div>
      <div className="row mt-5">
        <div className="col my-5">
          <Stations AQIType={AQIType} />
        </div>
      </div>
    </div>
  );
};

export default PayeshPage;
